import { render, staticRenderFns } from "./ReviewWorkflowPage.vue?vue&type=template&id=43102c48&scoped=true"
import script from "./ReviewWorkflowPage.vue?vue&type=script&lang=js"
export * from "./ReviewWorkflowPage.vue?vue&type=script&lang=js"
import style0 from "./ReviewWorkflowPage.vue?vue&type=style&index=0&id=43102c48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43102c48",
  null
  
)

export default component.exports